export class IntersectionObserverInitFactory {
    static create70() {
        return {
            root: null,
            rootMargin: '0px 0px -30% 0px',
            threshold: 0,
        };
    }
    static create100() {
        return {
            root: null,
            rootMargin: '0px',
            threshold: 1,
        };
    }
}
